import type { CommSrvTime } from '@ps/web-shared-api-types/v1-preview/SwHomeGames';
import type { FormatNumberOptions } from 'react-intl';

import type { ErrorBody } from '@swf/core/errors/RequestError';

export { createInviteUrl } from './createInviteUrl';
export { initModuleNativeClient } from './nativeClient';
export { sortClubs } from './sortClubs';
export { mapTableType, mapTournType } from './reducers';
export { filterTournaments } from './filterTournaments';
export { stripHTML } from './stripHTML';
export { calculateCurrencyAmount } from './calculateCurrencyAmount';
export {
  HandTypeTranslations,
  PotTypeTranslations,
  FormatTranslations,
  TournamentStateTranslations,
  SpeedTranslations,
  Speed,
  PlayMoney
} from './games';
export { parseHSPCriteria, criteriaMatches } from './HSPCriteria';

export { mustNotContainSymbols, mustBeLowerOrEqual, mustBeBiggerOrEqual } from './validators';
export * from './MTT';
interface Response {
  success?: boolean;
  message?: string;
}

interface Props<T> {
  response: Response & T;
  accessor: string;
}

interface ReturnType<R> {
  error?: string | null;
  message?: string | null;
  data: R & {
    errCode: number;
    errDesc?: string;
  };
}

export const handleServerResponse = <T, R>({ response, accessor }: Props<T>): ReturnType<R> => {
  const success = response?.success;
  const message = response?.message;
  const data = response?.[accessor];

  if (!data && message) {
    return { error: message, data };
  }

  if (!data) {
    throw new Error(
      `A key with the value of ${accessor} was not found in ${JSON.stringify(response)}`
    );
  }

  // Server error or empty param error
  if (!success) {
    return { error: message, data };
  }

  // If there was not server error we search for a client error.
  // errCode above 0 is treated as error.
  if (success && data.errCode > 0) {
    return { error: data.errDesc, data };
  }

  return { error: null, message, data };
};

// TODO: decide on error handling and iterate to implement it
export const handleServerError = ({ text }: ErrorBody): string => text;

export const getFormatOptionsRM = (
  isPlayMoney: boolean,
  currency?: string
): FormatNumberOptions => ({
  style: isPlayMoney ? 'decimal' : 'currency',
  currency,
  currencyDisplay: 'narrowSymbol',
  currencySign: 'standard',
  minimumFractionDigits: isPlayMoney ? 0 : 2,
  maximumFractionDigits: isPlayMoney ? 0 : 2
});

export function parseCommlibDate({ day, hour, minute, month, second, year }: CommSrvTime) {
  return new Date(
    Number(year),
    Number(month),
    Number(day),
    Number(hour),
    Number(minute),
    Number(second)
  );
}
